import { useEffect, useState } from "react";
import { CollectibleCardProps } from "./collectible-card-types";
import { CardContainer, CardImage, CardTitle, IconNumber } from "./style-component";
import { useNavigate } from "react-router-dom";
import ColorThief from "colorthief";
import brandData from "@/assets/brand.json"
import { CloseOutlined } from "@ant-design/icons";
import { useTheme } from "@/contexts/theme-context/useThemeContext";


const CollectibleCard: React.FC<CollectibleCardProps> = ({
  thumb_url,
  name,
  token_id,
  reward_type,
  showIconNumber = false,
  benefit_amount_to_win = 0,
  onClick,
  typeClick,
  children
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { contentBg = "#17242B80" } = theme?.theme?.colors?.theme || {};
  const [dominantColor, setDominantColor] = useState<string>(contentBg);
  const isERC20 = reward_type === 'ERC20';
  const newName = name;

  useEffect(() => {
    if (isERC20) return;
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.src = thumb_url;

    img.onload = () => {
      const colorThief = new ColorThief();
      const dominantRGB = colorThief.getColor(img);
      setDominantColor(`rgba(${dominantRGB[0]}, ${dominantRGB[1]}, ${dominantRGB[2]}, 0.5)`);
    };
  }, [thumb_url, isERC20]);

  const truncateTitle = (text: string, maxLength: number = 60) => {
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  const handleClick = () => {
    if (typeClick === 'mission-page') {
      onClick?.();
      return;
    }
    if (token_id) {
      navigate(`/collectible/${token_id}`);
    }
  };

  return (
    <CardContainer
      $isERC20={isERC20}
      $backgroundColor={dominantColor}
      onClick={(e) => {
        e.stopPropagation();
        handleClick();
      }}
      style={{ cursor: 'pointer' }}
    >
      <CardImage>
        <img
          src={thumb_url}
          alt={name}
        />
      </CardImage>
      {showIconNumber && isERC20 && (
        // <FloatText> 
        <IconNumber data-testid="balance-amount"><b>{benefit_amount_to_win}<CloseOutlined style={{ width: "8px" }} /></b>  {brandData.pages.wallet.currencies[0].title}</IconNumber>
        // </FloatText>
      )}
      <CardTitle className="title">
        {truncateTitle(newName ?? '')}
      </CardTitle>
      {children}
    </CardContainer>
  );
};

export default CollectibleCard;